module.exports = __webpack_public_path__ + "img/development (2).398142cb.png";